
import React from 'react';

interface ErrorStateProps {
  error: unknown;
}

const ErrorState: React.FC<ErrorStateProps> = ({ error }) => {
  return (
    <div className="bg-red-50 border border-red-200 rounded-lg p-4 text-red-700">
      Error loading interviews: {error instanceof Error ? error.message : 'Unknown error'}
    </div>
  );
};

export default ErrorState;
